import React from "react";
import Input from "@mui/joy/Input";


class Select extends React.Component {
    render(){
        return(
            <Input
                size="sm"
                name={this.props.name}
                defaultValue={this.props.defaultValue}
            />
        )
    }
}

export default Select